import { USERMASTER, VALIDCUSTOMERAPPOINMENTANAMONUS, VALIDOTP } from "../../utils/api";
import axios from "../../utils/axios"
import { Toast } from "../../utils/commonUtils";

export const otpApi=async(payload,callback)=>{ 
    await axios
    .post (payload.api,payload.payload)
    .then((res) => {
      console.log("res search ", res);
      
      if (res?.data?.succeeded === true) {
        callback(res.data);
        Toast.fire({
          icon: "success",
          title: res?.data?.message || "OTP verified successfully",
        });
      } else {
        Toast.fire({
          icon: "error",
          title: res?.data?.message || "Invalid OTP",
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
  
}